import React from "react";
import Chip, { ChipProps } from "@mui/material/Chip";
import { PermitStatus, PermitApplicationStatus } from "common/types/permits";

interface PermitStatusConfig {
  color: ChipProps["color"];
  label: string;
}

const permitStatusConfig: Record<PermitStatus, PermitStatusConfig> = {
  pending: { color: "warning", label: "Pending" },
  active: { color: "success", label: "Active" },
  expired: { color: "default", label: "Expired" },
  suspended: { color: "error", label: "Suspended" },
  pending_suspension: { color: "warning", label: "Pending Suspension" },
  denied: { color: "error", label: "Denied" },
};

const applicationStatusConfig: Record<PermitApplicationStatus, PermitStatusConfig> = {
  pending: { color: "warning", label: "Pending Review" },
  approved: { color: "success", label: "Approved" },
  denied: { color: "error", label: "Denied" },
  awaiting_additional_info: { color: "info", label: "Awaiting Info" },
};

export type PermitStatusBadgeProps = Omit<ChipProps, "color" | "label"> &
  (
    | {
        type: "permit";
        status: PermitStatus;
      }
    | {
        type: "application";
        status: PermitApplicationStatus;
      }
  );

export const PermitStatusBadge: React.FC<PermitStatusBadgeProps> = ({ type, status, ...chipProps }) => {
  const config =
    type === "permit"
      ? permitStatusConfig[status as PermitStatus]
      : applicationStatusConfig[status as PermitApplicationStatus];

  return <Chip color={config.color} label={config.label} size="small" {...chipProps} />;
};

export default PermitStatusBadge;
